import { useEffect, useState } from "react";

import NewMemberAccountService from "../services/member-account-service";

export default function Homepage() {
    const [data, setData] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await NewMemberAccountService.getStatistics();
                setData(res?.data);
            } catch (e) {
                console.error("Error fetching statistics. ", e);
            }
        }
        fetchData();
    }, []);

    return (
        <div className="">
            <div className="container mx-auto py-7 px-24">
            <h2 className="font-bold mb-12 text-[1.5rem]">Homepage</h2>
            <div className="border border-black rounded-3xl flex items-center py-12 px-14">
                <div className="w-1/2">
                    <p className="font-bold text-[1.25rem] mb-1">Registered User</p>
                    <p className="text-xs text-gray-500 mb-4">已啟用 一般會員+External 會員</p>
                    <p className="font-bold text-[2.25rem]">{data?.registeredUser}</p>
                </div>
                <div className="w-1/2 border-l border-black ps-14">
                    <p className="font-bold text-[1.25rem] mb-6">Subscribed User</p>
                    <p className="font-bold text-[2.25rem]">{data?.subscribedUser || "--"}</p>
                </div>
            </div>
            </div>
        </div>
    )
}